"use client";

//import Banner from "src/components/Banner";
//import Card from "src/components/NavCard";
import React from "react";
import { DynamicPage, FormIdentifier, MainLayout, PageWithLayout } from "@shesha-io/reactjs";

interface IProps {
  searchParams: Record<string, string | string[]>;
}

const Home: PageWithLayout<IProps> = (props) => {
  const { searchParams } = props;
  const formId: FormIdentifier = {
    module: "Boxfusion.ServiceManagement",
    name: "demo-service-request",
  };
  return (
    <MainLayout>
       <DynamicPage {...searchParams} formId={formId} /> 
    </MainLayout>
  );
};

export default Home;
